export const AGENT_REORDER = 'AGENT_REORDER';
export const AGENT_UPDATE = 'AGENT_UPDATE';
export const ANIMATE_SERVICE_CALL_LIST = 'ANIMATE_SERVICE_CALL_LIST';
export const APPOINTMENT_UPDATE = 'APPOINTMENT_UPDATE';
export const BEGIN_FETCH_LINKS = 'BEGIN_FETCH_LINKS';
export const BEGIN_FETCH_CONTACT_LINKS = 'BEGIN_FETCH_CONTACT_LINKS';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';
export const CLEAR_SELECTED_NAV_CLIENT = 'CLEAR_SELECTED_NAV_CLIENT';
export const CLEAR_SELECTED_NAV_SITE = 'CLEAR_SELECTED_NAV_SITE';
export const CLEAR_SELECTED_NAV_EQUIPMENT = 'CLEAR_SELECTED_NAV_EQUIPMENT';
export const CLEAR_SELECTED_NAV_SYSTEM = 'CLEAR_SELECTED_NAV_SYSTEM';
export const CLEAR_DASHBOARD_CLIENT_DATA = 'CLEAR_DASHBOARD_CLIENT_DATA';
export const CLEAR_DASHBOARD_SITE_DATA = 'CLEAR_DASHBOARD_SITE_DATA';
export const CLEAR_ENTITY_SENSOR_DATA = 'CLEAR_ENTITY_SENSOR_DATA';
export const CLEAR_ERP_ENTITIES = 'CLEAR_ERP_ENTITIES';
export const CREATE_CUSTOMER_SUPPORT_REPORT = 'CREATE_CUSTOMER_SUPPORT_REPORT';
export const CREATE_ERP_AGENT = 'CREATE_ERP_AGENT';
export const CREATE_LINK = 'CREATE_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const DEVICE_ADD = 'DEVICE_ADD';
export const DEVICE_REMOVE = 'DEVICE_REMOVE';
export const DEVICE_REORDER = 'DEVICE_REORDER';
export const DEVICE_TOGGLE_SELECT = 'DEVICE_TOGGLE_SELECT';
export const DEVICE_UPDATE = 'DEVICE_UPDATE';
export const DEVICES_TOGGLE = 'DEVICES_TOGGLE';
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const EQUIPMENT_TYPES_LOAD_BEGIN = 'EQUIPMENT_TYPES_LOAD_BEGIN';
export const EQUIPMENT_TYPES_LOAD_END = 'EQUIPMENT_TYPES_LOAD_END';
export const EQUIPMENT_TYPES_LOAD_ERROR = 'EQUIPMENT_TYPES_LOAD_ERROR';
export const ERP_AGENT_REORDER = 'ERP_AGENT_REORDER';
export const FETCH_AGENT_LOGS = 'FETCH_AGENT_LOGS';
export const FETCH_AGENT_LOG_ENTRIES = 'FETCH_AGENT_LOG_ENTRIES';
export const FETCH_ALL_COMPANIES = 'FETCH_ALL_COMPANIES';
export const FETCH_ALL_CONFIGURATION_DATA = 'FETCH_ALL_CONFIGURATION_DATA';
export const FETCH_ALL_SCOPES = 'FETCH_ALL_SCOPES';
export const FETCH_API_VERSION = 'FETCH_API_VERSION';
export const FETCH_APPLICATIONS = 'FETCH_APPLICATIONS';
export const FETCH_APPOINTMENT_STATUSES = 'FETCH_APPOINTMENT_STATUSES';
export const FETCH_AREAS = 'FETCH_AREAS';
export const FETCH_ATTRIBUTE_VALUES = 'FETCH_ATTRIBUTE_VALUES';
export const FETCH_ATTRIBUTES = 'FETCH_ATTRIBUTES';
export const FETCH_BACNET_INVENTORY = 'FETCH_BACNET_INVENTORY';
export const FETCH_BAS_AGENTS = 'FETCH_BAS_AGENTS';
export const FETCH_BAS_AGENTS_REPORT = 'FETCH_BAS_AGENTS_REPORT';
export const FETCH_BAS_TYPES = 'FETCH_BAS_TYPES';
export const FETCH_BUILDING_TYPES = 'FETCH_BUILDING_TYPES';
export const FETCH_BUSINESS_TYPES = 'FETCH_BUSINESS_TYPES';
export const FETCH_CALL_PRIORITIES = 'FETCH_CALL_PRIORITIES';
export const FETCH_CALL_STATUSES = 'FETCH_CALL_STATUSES';
export const FETCH_CAMPUS_SITES = 'FETCH_CAMPUS_SITES';
export const FETCH_CLIENT_CONTACTS = 'FETCH_CLIENT_CONTACTS';
export const FETCH_CLIENT_ENERGY_DATA = 'FETCH_CLIENT_ENERGY_DATA';
export const FETCH_CLIENT_ENERGY_EQUIPMENT = 'FETCH_CLIENT_ENERGY_EQUIPMENT';
export const FETCH_CLIENT_ENERGY_KPI = 'FETCH_CLIENT_ENERGY_KPI';
export const FETCH_CLIENT_EQUIPMENT_DATA = 'FETCH_CLIENT_EQUIPMENT_DATA';
export const FETCH_CLIENT_NODES = 'FETCH_CLIENT_NODES';
export const FETCH_CLIENT_SETTINGS = 'FETCH_CLIENT_SETTINGS';
export const FETCH_CLIENT_ENABLED_COMMS = 'FETCH_CLIENT_ENABLED_COMMS';
export const FETCH_CLIENT_SITES_DATA = 'FETCH_CLIENT_SITES_DATA';
export const FETCH_CLIENT_SYSTEMS_DATA = 'FETCH_CLIENT_SYSTEMS_DATA';
export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const FETCH_CLIENTS_DATA = 'FETCH_CLIENTS_DATA';
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_COMPANY_ALIAS = 'FETCH_COMPANY_ALIAS';
export const FETCH_COMPANY_ENERGY_DATA = 'FETCH_COMPANY_ENERGY_DATA';
export const FETCH_COMPANY_INFO = 'FETCH_COMPANY_INFO';
export const FETCH_COMPANY_KPI_DATA = 'FETCH_COMPANY_KPI_DATA';
export const FETCH_COMPANY_METRICS = 'FETCH_COMPANY_METRICS';
export const FETCH_COMPANY_SITES = 'FETCH_COMPANY_SITES';
export const FETCH_CONFIG_ENTITIES = 'FETCH_CONFIG_ENTITIES';
export const FETCH_CONTACT_LINKS = 'FETCH_CONTACT_LINKS';
export const FETCH_CONTRACTOR_TYPES = 'FETCH_CONTRACTOR_TYPES';
export const FETCH_CONTACT_SUBSCRIPTIONS = 'FETCH_CONTACT_SUBSCRIPTIONS';
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const FETCH_CONVERSIONS = 'FETCH_CONVERSIONS';
export const FETCH_CONFIGURATION_DATA = 'FETCH_CONFIGURATION_DATA';
export const FETCH_CORE_AREAS = 'FETCH_CORE_AREAS';
export const FETCH_CORE_CLIENTS = 'FETCH_CORE_CLIENTS';
export const FETCH_CORE_CONTACTS = 'FETCH_CORE_CONTACTS';
export const FETCH_CORE_EQUIPMENT = 'FETCH_CORE_EQUIPMENT';
export const FETCH_CORE_SITES = 'FETCH_CORE_SITES';
export const FETCH_CORE_SYSTEMS = 'FETCH_CORE_SYSTEMS';
export const FETCH_CURRENT_APP = 'FETCH_CURRENT_APP';
export const FETCH_CURRENT_USER_ROLE = 'FETCH_CURRENT_USER_ROLE';
export const FETCH_CURRENT_SITE_WEATHER_DATA = 'FETCH_CURRENT_SITE_WEATHER_DATA';
export const FETCH_DASHBOARD_CONVERSIONS = 'FETCH_DASHBOARD_CONVERSIONS';
export const FETCH_DASHBOARD_EQUIPMENT_TYPES = 'FETCH_DASHBOARD_EQUIPMENT_TYPES';
export const FETCH_DASHBOARD_SENSOR_TYPES = 'FETCH_DASHBOARD_SENSOR_TYPES';
export const FETCH_DEFAULT_COMPANY = 'FETCH_DEFAULT_COMPANY';
export const FETCH_DEVICES = 'FETCH_DEVICES';
export const FETCH_DEVICES_AND_OBJECTS = 'FETCH_DEVICES_AND_OBJECTS';
export const FETCH_DEVICE_OBJECTS = 'FETCH_DEVICE_OBJECTS';
export const FETCH_ENERGY_EQUIPMENT = 'FETCH_ENERGY_EQUIPMENT';
export const FETCH_ENERGY_SITES = 'FETCH_ENERGY_SITES';
export const FETCH_ENERGY_EQUIPMENT_SUMMARY = 'FETCH_ENERGY_EQUIPMENT_SUMMARY';
export const FETCH_ENERGY_EQUIPMENT_GROUP = 'FETCH_ENERGY_EQUIPMENT_GROUP';
export const FETCH_ENTITY_SENSORS = 'FETCH_ENTITY_SENSORS';
export const FETCH_ENTITY_SENSORS_TABLE = 'FETCH_ENTITY_SENSORS_TABLE';
export const FETCH_EQUIPMENT = 'FETCH_EQUIPMENT';
export const FETCH_EQUIPMENT_AVOIDED_COSTS = 'FETCH_EQUIPMENT_AVOIDED_COSTS';
export const FETCH_EQUIPMENT_DATA = 'FETCH_EQUIPMENT_DATA';
export const FETCH_EQUIPMENT_FUTURE_SAVINGS = 'FETCH_EQUIPMENT_FUTURE_SAVINGS';
export const FETCH_EQUIPMENT_ENERGY_DATA = 'FETCH_EQUIPMENT_ENERGY_DATA';
export const FETCH_EQUIPMENT_ENERGY_KPI = 'FETCH_EQUIPMENT_ENERGY_KPI';
export const FETCH_EQUIPMENT_KPI_DATA = 'FETCH_EQUIPMENT_KPI_DATA';
export const FETCH_EQUIPMENT_MANUFACTURERS = 'FETCH_EQUIPMENT_MANUFACTURERS';
export const FETCH_EQUIPMENT_RULES = 'FETCH_EQUIPMENT_RULES';
export const FETCH_EQUIPMENT_TYPES = 'FETCH_EQUIPMENT_TYPES';
export const FETCH_ENERGY_INTEGRATIONS = 'FETCH_ENERGY_INTEGRATIONS';
export const FETCH_ENERGY_KPI_DATA = 'FETCH_ENERGY_KPI_DATA';
export const FETCH_ENTITY_RULES = 'FETCH_ENTITY_RULES';
export const FETCH_ERP_AGENTS = 'FETCH_ERP_AGENTS';
export const FETCH_ERP_AGENT_CONFIGURATIONS = 'FETCH_ERP_AGENT_CONFIGURATIONS';
export const FETCH_ERP_CONTACTS = 'FETCH_ERP_CONTACTS';
export const FETCH_ERP_SERVICE_APPOINTMENT_MAPPING = 'FETCH_ERP_SERVICE_APPOINTMENT_MAPPING';
export const FETCH_ERP_SERVICE_CALL_MAPPING = 'FETCH_ERP_SERVICE_CALL_MAPPING';
export const FETCH_ERP_STATUSES = 'FETCH_ERP_STATUSES';
export const FETCH_ERP_TECHNICIANS = 'FETCH_ERP_TECHNICIANS';
export const FETCH_ERP_EQUIPMENT = 'FETCH_ERP_EQUIPMENT';
export const FETCH_ERP_SITES = 'FETCH_ERP_SITES';
export const FETCH_ERP_CLIENTS = 'FETCH_ERP_CLIENTS';
export const FETCH_EXTERNAL_STATUSES = 'FETCH_EXTERNAL_STATUSES';
export const FETCH_FACETS = 'FETCH_FACETS';
export const FETCH_FAULT_BY_PRIORITY = 'FETCH_FAULT_BY_PRIORITY';
export const FETCH_FAULT_BY_RULE = 'FETCH_FAULT_BY_RULE';
export const FETCH_FAULT_HISTORY = 'FETCH_FAULT_HISTORY';
export const FETCH_FAULT_OVERLAY = 'FETCH_FAULT_OVERLAY';
export const FETCH_FAULT_SUMMARY = 'FETCH_FAULT_SUMMARY';
export const FETCH_FILTERED_AREAS = 'FETCH_FILTERED_AREAS';
export const FETCH_FILTERED_EQUIPMENT = 'FETCH_FILTERED_EQUIPMENT';
export const FETCH_FILTERED_SYSTEMS = 'FETCH_FILTERED_SYSTEMS';
export const FETCH_FUEL_TYPES = 'FETCH_FUEL_TYPES';
export const FETCH_HEALTH_CHECKS = 'FETCH_HEALTH_CHECKS';
export const FETCH_HEALTHSCORE_RAW_DATA = 'FETCH_HEALTHSCORE_RAW_DATA';
export const FETCH_INTEGRATIONS = 'FETCH_INTEGRATIONS';
export const FETCH_INSPECTION_REPORTS = 'FETCH_INSPECTION_REPORTS';
export const FETCH_INVENTORY = 'FETCH_INVENTORY';
export const FETCH_ISSUE_TYPES = 'FETCH_ISSUE_TYPES';
export const FETCH_JOB_ISSUE_TYPES = 'FETCH_JOB_ISSUE_TYPES';
export const FETCH_JOB_SKILL_TYPES = 'FETCH_JOB_SKILL_TYPES';
export const FETCH_JOB_SKILL_LEVEL = 'FETCH_JOB_SKILL_LEVEL';
export const FETCH_KNOWI_CREDENTIALS = 'FETCH_KNOWI_CREDENTIALS';
export const FETCH_LINKS = 'FETCH_LINKS';
export const FETCH_MAPPED_ERP_CLIENTS = 'FETCH_MAPPED_ERP_CLIENTS';
export const FETCH_MAPPED_ERP_TECHNICIANS = 'FETCH_MAPPED_ERP_TECHNICIANS';
export const FETCH_NAV_CLIENTS = 'FETCH_NAV_CLIENTS';
export const FETCH_NAV_EQUIPMENT = 'FETCH_NAV_EQUIPMENT';
export const FETCH_NAV_SITES = 'FETCH_NAV_SITES';
export const FETCH_NAV_SYSTEMS = 'FETCH_NAV_SYSTEMS';
export const FETCH_PREVIEW_WEATHER_DATA = 'FETCH_PREVIEW_WEATHER_DATA';
export const FETCH_PROFILES = 'FETCH_PROFILES';
export const FETCH_PROFILE_OBJECTS = 'FETCH_PROFILE_OBJECTS';
export const FETCH_RAW_UNITS = 'FETCH_RAW_UNITS';
export const FETCH_ROLES = 'FETCH_ROLES';
export const FETCH_RULE_LIST = 'FETCH_RULE_LIST';
export const FETCH_RULE_TARGETS = 'FETCH_RULE_TARGETS';
export const FETCH_RULE_KPIS = 'FETCH_RULE_KPIS';
export const FETCH_RULE_SCORE_KPIS = 'FETCH_RULE_SCORE_KPIS';
export const FETCH_RULES = 'FETCH_RULES';
export const FETCH_SCHEDULE_TECHNICIANS = 'FETCH_SCHEDULE_TECHNICIANS';
export const FETCH_SCHEDULED_APPOINTMENTS = 'FETCH_SCHEDULED_APPOINTMENTS';
export const FETCH_SCORING = 'FETCH_SCORING';
export const FETCH_SCORING_DATA = 'FETCH_SCORING_DATA';
export const FETCH_SENSORS = 'FETCH_SENSORS';
export const FETCH_SENSOR_CALCULATIONS = 'FETCH_SENSOR_CALCULATIONS';
export const FETCH_SENSOR_COUNT_REPORT = 'FETCH_SENSOR_COUNT_REPORT';
export const SET_CLONED_FORMULA = 'SET_CLONED_FORMULA';
export const FETCH_FORMULA_LIST = 'FETCH_FORMULA_LIST';
export const FETCH_COMPANY_FORMULA_LIST = 'FETCH_COMPANY_FORMULA_LIST';
export const SENSOR_SAVE_EVENT = 'SENSOR_SAVE_EVENT';
export const SET_FORMULA_DETAILS = 'SET_FORMULA_DETAILS';
export const SET_FORMULA_GRID_COLUMNS = 'SET_FORMULA_GRID_COLUMNS';
export const SET_TEMPLATE_DETAILS = 'SET_TEMPLATE_DETAILS';
export const FETCH_SENSOR_TEMPLATE = 'FETCH_SENSOR_TEMPLATE';
export const FETCH_SENSOR_DATA = 'FETCH_SENSOR_DATA';
export const FETCH_SENSOR_TYPES = 'FETCH_SENSOR_TYPES';
export const FETCH_SERVICE_ITEM_LIST = 'FETCH_SERVICE_ITEM_LIST';
export const FETCH_SERVICE_APPOINTMENT_STATUSES = 'FETCH_SERVICE_APPOINTMENT_STATUSES';
export const FETCH_SERVICE_CALL_STATUSES = 'FETCH_SERVICE_CALL_STATUSES';
export const FETCH_SERVICE_STATUS_SETTINGS = 'FETCH_SERVICE_STATUS_SETTINGS';
export const FETCH_SITE_AVOIDED_COSTS = 'FETCH_SITE_AVOIDED_COSTS';
export const FETCH_SITE_FUTURE_SAVINGS = 'FETCH_SITE_FUTURE_SAVINGS';
export const FETCH_SITES = 'FETCH_SITES';
export const FETCH_SITE_CONTACTS = 'FETCH_SITE_CONTACTS';
export const FETCH_SITE_ENERGY_DATA = 'FETCH_SITE_ENERGY_DATA';
export const FETCH_SITE_ENERGY_KPI = 'FETCH_SITE_ENERGY_KPI';
export const FETCH_SITE_EQUIPMENT_DATA = 'FETCH_SITE_EQUIPMENT_DATA';
export const FETCH_SITE_KPI_DATA = 'FETCH_SITE_KPI_DATA';
export const FETCH_SITE_EQUIPMENT_KPI_DATA = 'FETCH_SITE_EQUIPMENT_KPI_DATA';
export const FETCH_SITE_SCORE_DATA = 'FETCH_SITE_SCORE_DATA';
export const FETCH_SITE_SYSTEM_KPI_DATA = 'FETCH_SITE_SYSTEM_KPI_DATA';
export const FETCH_SITES_DATA = 'FETCH_SITES_DATA';
export const FETCH_SITE_SYSTEMS_DATA = 'FETCH_SITE_SYSTEMS_DATA';
export const FETCH_SM_AREAS = 'FETCH_SM_AREAS';
export const FETCH_SM_CLIENTS = 'FETCH_SM_CLIENTS';
export const FETCH_SM_CONTACTS = 'FETCH_SM_CONTACTS';
export const FETCH_SM_EQUIPMENT_AND_SYSTEMS = 'FETCH_SM_EQUIPMENT_AND_SYSTEMS';
export const FETCH_SM_RULES = 'FETCH_SM_RULES';
export const FETCH_SM_SITES = 'FETCH_SM_SITES';
export const FETCH_SM_TECHNICIAN_LIST = 'FETCH_SM_TECHNICIAN_LIST';
export const FETCH_SOURCES = 'FETCH_SOURCES';
export const FETCH_SYSTEM_EQUIPMENT_DATA = 'FETCH_SYSTEM_EQUIPMENT_DATA';
export const FETCH_SYSTEM_KPI_DATA = 'FETCH_SYSTEM_KPI_DATA';
export const FETCH_SYSTEMS = 'FETCH_SYSTEMS';
export const FETCH_SYSTEMS_BY_SITE = 'FETCH_SYSTEMS_BY_SITE';
export const FETCH_SYSTEMS_DATA = 'FETCH_SYSTEMS_DATA';
export const FETCH_SYSTEM_TYPES = 'FETCH_SYSTEM_TYPES';
export const FETCH_SERVICE_REQUEST_LIST = 'FETCH_SERVICE_REQUEST_LIST';
export const FETCH_TECHNICIAN_LIST = 'FETCH_TECHNICIAN_LIST';
export const FETCH_TECHNICIAN_SENIORITY_LEVELS = 'FETCH_TECHNICIAN_SENIORITY_LEVELS';
export const FETCH_TECHNICIAN_SPECIALTIES = 'FETCH_TECHNICIAN_SPECIALTIES';
export const FETCH_UNSCHEDULED_APPOINTMENTS = 'FETCH_UNSCHEDULED_APPOINTMENTS';
export const FETCH_USER_SUBSCRIPTIONS = 'FETCH_USER_SUBSCRIPTIONS';
export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const FETCH_USER_ENTITIES = 'FETCH_USER_ENTITIES';
export const FETCH_WEATHER_DATA = 'FETCH_WEATHER_DATA';
export const FETCH_WEATHER_SENSOR_DATA = 'FETCH_WEATHER_SENSOR_DATA';
export const FETCH_WEATHER_STATION = 'FETCH_WEATHER_STATION';
export const FETCH_WORST_PERFORMING_EQUIPMENT = 'FETCH_WORST_PERFORMING_EQUIPMENT';
export const INVENTORY_LOAD_BEGIN = 'INVENTORY_LOAD_BEGIN';
export const INVENTORY_LOAD_END = 'INVENTORY_LOAD_END';
export const INVENTORY_LOAD_ERROR = 'INVENTORY_LOAD_ERROR';
export const INVENTORY_RESET = 'INVENTORY_RESET';
export const INVENTORY_TOGGLE_SELECT = 'INVENTORY_TOGGLE_SELECT';
export const INVENTORY_UPDATE = 'INVENTORY_UPDATE';
export const IS_SIGNED_IN = 'IS_SIGNED_IN';
export const IS_SIGNED_OUT = 'IS_SIGNED_OUT';
export const ITEM_REORDER = 'ITEM_REORDER';
export const PROFILE_OBJECT_REMOVE = 'PROFILE_OBJECT_REMOVE';
export const PROFILE_OBJECT_REORDER = 'PROFILE_OBJECTS_REORDER';
export const PROFILE_OBJECT_RESET = 'PROFILE_OBJECT_RESET';
export const PROFILE_OBJECT_TOGGLE_SELECT = 'PROFILE_OBJECT_TOGGLE_SELECT';
export const PROFILE_OBJECT_UPDATE = 'PROFILE_OBJECTS_UPDATE';
export const PROFILE_REMOVE = 'PROFILE_REMOVE';
export const PROFILE_REORDER = 'PROFILE_REORDER';
export const PROFILE_TOGGLE_SELECT = 'PROFILE_TOGGLE_SELECT';
export const PROFILE_UPDATE = 'PROFILE_UPDATE';
export const REDUX_WEBSOCKET_BEGIN_RECONNECT = 'REDUX_WEBSOCKET::BEGIN_RECONNECT';
export const REDUX_WEBSOCKET_BROKEN = 'REDUX_WEBSOCKET::BROKEN';
export const REDUX_WEBSOCKET_CLOSED = 'REDUX_WEBSOCKET::CLOSED';
export const REDUX_WEBSOCKET_CONNECT = 'REDUX_WEBSOCKET::CONNECT';
export const REDUX_WEBSOCKET_ERROR = 'REDUX_WEBSOCKET::ERROR';
export const REDUX_WEBSOCKET_MESSAGE = 'REDUX_WEBSOCKET::MESSAGE';
export const REDUX_WEBSOCKET_OPEN = 'REDUX_WEBSOCKET::OPEN';
export const REDUX_WEBSOCKET_RECONNECTED = 'REDUX_WEBSOCKET::RECONNECTED';
export const REDUX_WEBSOCKET_RECONNECT_ATTEMPT = 'REDUX_WEBSOCKET::RECONNECT_ATTEMPT';
export const REDUX_WEBSOCKET_SEND = 'REDUX_WEBSOCKET::SEND';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const RESET_AGENT_LOG_FILTERS = 'RESET_AGENT_LOG_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_LISTS = 'RESET_LISTS';
export const RESET_LOAD_PROGRESS_SETTINGS = 'RESET_LOAD_PROGRESS_SETTINGS';
export const RESET_WIZARD = 'RESET_WIZARD';
export const RULES_DELETE = 'RULES_DELETE';
export const RULES_UPDATE = 'RULES_UPDATE';
export const SCORING_LOAD_BEGIN = 'SCORING_LOAD_BEGIN';
export const SCORING_LOAD_END = 'SCORING_LOAD_END';
export const SCORING_LOAD_ERROR = 'SCORING_LOAD_ERROR';
export const SENSOR_DATA_LOAD_BEGIN = 'SENSOR_DATA_LOAD_BEGIN';
export const SENSOR_DATA_LOAD_END = 'SENSOR_DATA_LOAD_END';
export const SENSOR_DATA_LOAD_ERROR = 'SENSOR_DATA_LOAD_ERROR';
export const SENSOR_TYPES_LOAD_BEGIN = 'SENSOR_TYPES_LOAD_BEGIN';
export const SENSOR_TYPES_LOAD_END = 'SENSOR_TYPES_LOAD_END';
export const SENSOR_TYPES_LOAD_ERROR = 'SENSOR_TYPES_LOAD_ERROR';
export const SET_ACTIVE_APPOINTMENT = 'SET_ACTIVE_APPOINTMENT';
export const SET_ACTIVE_ITEM = 'SET_ACTIVE_ITEM';
export const SET_ACTIVE_NAV_CLIENT = 'SET_ACTIVE_NAV_CLIENT';
export const SET_ACTIVE_NAV_COMPANY = 'SET_ACTIVE_NAV_COMPANY';
export const SET_ACTIVE_NAV_EQUIPMENT = 'SET_ACTIVE_NAV_EQUIPMENT';
export const SET_ACTIVE_NAV_SITE = 'SET_ACTIVE_NAV_SITE';
export const SET_ACTIVE_RULE = 'SET_ACTIVE_RULE';
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const SET_ACTIVE_CONFIGURATION = 'SET_ACTIVE_CONFIGURATION';
export const SET_AGENT = 'SET_AGENT';
export const SET_AGENT_LOG = 'SET_AGENT_LOG';
export const SET_AGENT_LOG_END_TIMESTAMP = 'SET_AGENT_LOG_END_TIMESTAMP';
export const SET_AGENT_LOG_META_DATA = 'SET_AGENT_LOG_META_DATA';
export const SET_AGENT_LOG_SEARCH_VALUE = 'SET_AGENT_LOG_SEARCH_VALUE';
export const SET_AGENT_LOG_START_TIMESTAMP = 'SET_AGENT_LOG_START_TIMESTAMP';
export const SET_AGENT_NAME = 'SET_AGENT_NAME';
export const SET_ALL_SENSORS = 'SET_ALL_SENSORS';
export const SET_ALL_ROLES = 'SET_ALL_ROLES';
export const SET_AM_ENTITIES = 'SET_AM_ENTITIES';
export const SET_AM_SELECTED_ATTRIBUTE_VALUE = 'SET_AM_SELECTED_ATTRIBUTE_VALUE';
export const SET_AM_SELECTED_STATE = 'SET_AM_SELECTED_STATE';
export const SET_APPLICATION_ERROR = 'SET_APPLICATION_ERROR';
export const SET_AREA = 'SET_AREA';
export const SET_ARE_FILTERS_APPLIED = 'SET_ARE_FILTERS_APPLIED';
export const SET_AW_LOAD_MESSAGE = 'SET_AW_LOAD_MESSAGE';
export const SET_AW_MESSAGE_MODAL_OPEN = 'SET_AW_MESSAGE_MODAL_OPEN';
export const SET_AW_PROCESS_IDS = 'SET_AW_PROCESS_IDS';
export const SET_AW_TOTAL_SENSORS = 'SET_AW_TOTAL_SENSORS';
export const SET_BOB_LOADING = 'SET_BOB_LOADING';
export const SET_BOOTSTRAPPING = 'SET_BOOTSTRAPPING';
export const SET_CALL_ISSUES = 'SET_CALL_ISSUES';
export const SET_CALL_SOURCES_FILTER = 'SET_CALL_SOURCES_FILTER';
export const SET_CALL_STATUS = 'SET_CALL_STATUS';
export const SET_CALL_STATUSES_FILTER = 'SET_CALL_STATUSES_FILTER';
export const SET_CLIENT = 'SET_CLIENT';
export const SET_CLIENT_FILTERS = 'SET_CLIENT_FILTERS';
export const SET_CLIENT_SETTINGS_LOADING = 'SET_CLIENT_SETTINGS_LOADING';
export const SET_CLIENT_SETTINGS_SEARCH_VALUE = 'SET_CLIENT_SETTINGS_SEARCH_VALUE';
export const SET_CLIENTS_FILTER = 'SET_CLIENTS_FILTER';
export const SET_CONFIG_SENSORS = 'SET_CONFIG_SENSORS';
export const SET_CONTACT = 'SET_CONTACT';
export const SET_CONVERSION = 'SET_CONVERSION';
export const SET_CONFIGURATION_DATA = 'SET_CONFIGURATION_DATA';
export const SET_COMPANY_APPLICATIONS = 'SET_COMPANY_APPLICATIONS';
export const SET_CORE_CLIENT = 'SET_CORE_CLIENT';
export const SET_CORE_SITE = 'SET_CORE_SITE';
export const SET_CORE_EQUIPMENT = 'SET_CORE_EQUIPMENT';
export const SET_CORE_SYSTEM = 'SET_CORE_SYSTEM';
export const SET_CLIENT_TAB_INDEX = 'SET_CLIENT_TAB_INDEX';
export const SET_COMPANY_TAB_INDEX = 'SET_COMPANY_TAB_INDEX';
export const SET_CURRENT_SCOPES = 'SET_CURRENT_SCOPES';
export const SET_CUSTOMER_SEARCH_VALUE ='SET_CUSTOMER_SEARCH_VALUE';
export const SET_CUSTOMER_TRACKING_LOADING = 'SET_CUSTOMER_TRACKING_LOADING';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CUSTOM_ATTRIBUTES = 'SET_CUSTOM_ATTRIBUTES';
export const SET_DASHBOARD_BULK_CREATED = 'SET_DASHBOARD_BULK_CREATED';
export const SET_DASHBOARD_TIMEFRAME_END = 'SET_DASHBOARD_TIMEFRAME_END';
export const SET_DASHBOARD_TIMEFRAME_START = 'SET_DASHBOARD_TIMEFRAME_START';
export const SET_DASHBOARD_TIME_PERIOD = 'SET_DASHBOARD_TIME_PERIOD';
export const SET_DASHBOARD_END_TIMESTAMP = 'SET_DASHBOARD_END_TIMESTAMP';
export const SET_DASHBOARD_ISCURRENT_TIMESTAMP = 'SET_DASHBOARD_ISCURRENT_TIMESTAMP';
export const SET_DASHBOARD_CURRENT_TIMESTAMP = 'SET_DASHBOARD_CURRENT_TIMESTAMP';
export const SET_DASHBOARD_START_TIMESTAMP = 'SET_DASHBOARD_START_TIMESTAMP';
export const SET_DESIRED_INTERVAL = 'SET_DESIRED_INTERVAL';
export const SET_DEVICE = 'SET_DEVICE';
export const SET_DEVICES_LOADING = 'SET_DEVICES_LOADING';
export const SET_DEVICE_PROCESS_IDS = 'SET_DEVICE_PROCESS_IDS';
export const SET_DEVICE_TOTAL = 'SET_DEVICE_TOTAL';
export const SET_DRAWER_OPEN = 'SET_DRAWER_OPEN';
export const SET_EMAILS = 'SET_EMAILS';
export const SET_ENTITY_RULES = 'SET_ENTITY_RULES';
export const SET_ENTITY_SENSOR_DATA = 'SET_ENTITY_SENSOR_DATA';
export const SET_ENTITY_SENSORS = 'SET_ENTITY_SENSORS';
export const SET_ENTITY_SCORES_DATA = 'SET_ENTITY_SCORES_DATA';
export const SET_ENTITY_SCORING_DATA = 'SET_ENTITY_SCORING_DATA';
export const SET_ERP_AGENT = 'SET_ERP_AGENT';
export const SET_ERP_AGENT_LOADING = 'SET_ERP_AGENT_LOADING';
export const SET_ERP_AGENTS_LOADING = 'SET_ERP_AGENTS_LOADING';
export const SET_END_TIMESTAMP = 'SET_END_TIMESTAMP';
export const SET_EQUIPMENT = 'SET_EQUIPMENT';
export const SET_EQUIPMENT_CREATED = 'SET_EQUIPMENT_CREATED';
export const SET_EQUIPMENT_FILTER = 'SET_EQUIPMENT_FILTER';
export const SET_EQUIPMENT_FILTERS = 'SET_EQUIPMENT_FILTERS';
export const SET_EQUIPMENT_PROCESS_DATA = 'SET_EQUIPMENT_PROCESS_DATA';
export const SET_EQUIPMENT_PROCESS_IDS = 'SET_EQUIPMENT_PROCESS_IDS';
export const SET_EQUIPMENT_TAB_INDEX = 'SET_EQUIPMENT_TAB_INDEX';
export const SET_EQUIPMENT_TYPE_NAME = 'SET_EQUIPMENT_TYPE_NAME';
export const SET_FAULT_DATA = 'SET_FAULT_DATA';
export const SET_CUSTOMERS_LOADING = 'SET_CUSTOMERS_LOADING';
export const SET_ISSUE_TYPES_FILTER = 'SET_ISSUE_TYPES_FILTER';
export const SET_ITEM_IS_ACTIVE = 'SET_ITEM_IS_ACTIVE';
export const SET_LEGACY_RULE_TABLE_PAGE_SIZE = 'SET_LEGACY_RULE_TABLE_PAGE_SIZE';
export const SET_LINK = 'SET_LINK';
export const SET_LOAD_PROGRESS_SETTINGS = 'SET_LOAD_PROGRESS_SETTINGS';
export const SET_NAV_CLIENT = 'SET_NAV_CLIENT';
export const SET_NAV_COMPANY = 'SET_NAV_COMPANY';
export const SET_NAV_SITE = 'SET_NAV_SITE';
export const SET_NAV_EQUIPMENT = 'SET_NAV_EQUIPMENT';
export const SET_NAV_SYSTEM = 'SET_NAV_SYSTEM';
export const SET_NODE = 'SET_NODE';
export const SET_NODE_UPDATE = 'SET_NODE_UPDATE';
export const SET_PRIORITY = 'SET_PRIORITY';
export const SET_PRIORITIES_FILTER = 'SET_PRIORITIES_FILTER';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_PROFILE_OBJECT_PROCESS_DATA = 'SET_PROFILE_OBJECT_PROCESS_DATA';
export const SET_PROFILE_OBJECT_PROCESS_IDS = 'SET_PROFILE_OBJECT_PROCESS_IDS';
export const SET_PROGRESS_BAR_LOADING = 'SET_PROGRESS_BAR_LOADING';
export const SET_ROLE = 'SET_ROLE';
export const SET_CARD_SCORES = 'SET_CARD_SCORES';
export const SET_NODE_SCORE = 'SET_NODE_SCORE';
export const SET_PREVIOUS_WEATHER_DATA = 'SET_PREVIOUS_WEATHER_DATA';
export const SET_PROCESS_ID = 'SET_PROCESS_ID';
export const SET_PROFILE_NAME = 'SET_PROFILE_NAME';
export const SET_RULE_SCORING_CONFIGURATION = 'SET_RULE_SCORING_CONFIGURATION';
export const SET_RULE_START_TIMESTAMP = 'SET_RULE_START_TIMESTAMP';
export const SET_RULE_END_TIMESTAMP = 'SET_RULE_END_TIMESTAMP';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_SELECTED_AGENT = 'SET_SELECTED_AGENT';
export const SET_SELECTED_CONTACT = 'SET_SELECTED_CONTACT';
export const SET_SELECTED_CONVERSION = 'SET_SELECTED_CONVERSION';
export const SET_SELECTED_REPORT = 'SET_SELECTED_REPORT';
export const SET_SELECTED_RULE = 'SET_SELECTED_RULE';
export const SET_SELECTED_RULE_FROM_FAULTS_PAGE = 'SET_SELECTED_RULE_FROM_FAULTS_PAGE';
export const SET_SELECTED_RULE_SENSORS = 'SET_SELECTED_RULE_SENSORS';
export const SET_SELECTED_SENSOR = 'SET_SELECTED_SENSOR';
export const SET_SELECTED_SENSORS = 'SET_SELECTED_SENSORS';
export const SET_SELECTED_TECHNICIAN = 'SET_SELECTED_TECHNICIAN';
export const SET_SELECTED_WEATHER_SENSORS = 'SET_SELECTED_WEATHER_SENSORS';
export const SET_SENSOR = 'SET_SENSOR';
export const SET_SENSOR_CONFIGURATION = 'SET_SENSOR_CONFIGURATION';
export const SET_SENSOR_PROCESS_DATA = 'SET_SENSOR_PROCESS_DATA';
export const SET_SENSOR_PROCESS_IDS = 'SET_SENSOR_PROCESS_IDS';
export const SET_SENSORS_CREATED = 'SET_SENSORS_CREATED';
export const SET_SENSORS_CREATED_EVENT = 'SET_SENSORS_CREATED_EVENT';
export const SET_SENSORS_ERROR_DETAILS = 'SET_SENSORS_ERROR_DETAILS';
export const SET_SERVICE_STATUS_SETTINGS_LOADING = 'SET_SERVICE_STATUS_SETTINGS_LOADING';
export const SET_SITE = 'SET_SITE';
export const SET_SITE_FAULT_SUMMARY = 'SET_SITE_FAULT_SUMMARY';
export const SET_SITE_FILTERS = 'SET_SITE_FILTERS';
export const SET_SITES_FILTER = 'SET_SITES_FILTER';
export const SET_SITE_TAB_INDEX = 'SET_SITE_TAB_INDEX';
export const SET_SM_AREA = 'SET_SM_AREA';
export const SET_SM_CLIENT = 'SET_SM_CLIENT';
export const SET_SM_CONTACT = 'SET_SM_CONTACT';
export const SET_SM_EQUIPMENT_OR_SYSTEM = 'SET_SM_EQUIPMENT_OR_SYSTEM';
export const SET_SM_SITE = 'SET_SM_SITE';
export const SET_SORTBY_FILTER = 'SET_SORTBY_FILTER';
export const SET_START_TIMESTAMP = 'SET_START_TIMESTAMP';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const SET_SUMMARIES = 'SET_SUMMARIES';
export const SET_SYSTEM = 'SET_SYSTEM';
export const SET_SYSTEM_TAB_INDEX = 'SET_SYSTEM_TAB_INDEX';
export const SET_SHOW_EXPORT_MODAL = 'SET_SHOW_EXPORT_MODAL';
export const SET_SYSTEM_FILTERS = 'SET_SYSTEM_FILTERS'; 
export const SET_HEALTH_MONITOR_FILTERS = 'SET_HEALTH_MONITOR_FILTERS';
export const SET_SYSTEMS_FILTER = 'SET_SYSTEMS_FILTER';
export const SET_SVC_REQUEST = 'SET_SVC_REQUEST';
export const SET_SVC_REQUEST_RAW = 'SET_SVC_REQUEST_RAW';
export const SET_TAB = 'SET_TAB';
export const SET_TARGET_AGENT = 'SET_TARGET_AGENT';
export const SET_TARGET_DEVICES = 'SET_TARGET_DEVICES';
export const SET_TARGET_EQUIPMENT = 'SET_TARGET_EQUIPMENT';
export const SET_TARGET_EQUIPMENT_CONFIG = 'SET_TARGET_EQUIPMENT_CONFIG';
export const SET_TARGET_PROFILES = 'SET_TARGET_PROFILES';
export const SET_TARGET_PROFILE = 'SET_TARGET_PROFILE';
export const SET_TARGET_PROFILE_OBJECTS = 'SET_TARGET_PROFILE_OBJECTS';
export const SET_TARGET_SENSORS = 'SET_TARGET_SENSORS'; 
export const SET_TARGET_SITE = 'SET_TARGET_SITE';
export const SET_TECHNICIANS_LOADING = 'SET_TECHNICIANS_LOADING';
export const SET_TECHNICIAN_TRACKING_LOADING = 'SET_TECHNICIAN_TRACKING_LOADING';
export const SET_TECHNICIAN_SEARCH_VALUE = 'SET_TECHNICIAN_SEARCH_VALUE';
export const SET_TREE = 'SET_TREE';
export const SET_TREE_RESET = 'SET_TREE_RESET';
export const SET_TREE_TYPE = 'SET_TREE_TYPE';
export const SET_WATCHDOG_REPORTS = 'SET_WATCHDOG_REPORTS';
export const SET_WIZARD_COMPLETE = 'SET_WIZARD_COMPLETE';
export const SET_VALIDATE_FORM = 'SET_VALIDATE_FORM';
export const SET_WORKBOOK_MODE = 'SET_WORKBOOK_MODE';
export const SET_IS_FROM_RULES_GRID = 'SET_IS_FROM_RULES_GRID';
export const SHOW_SAVE_CONFIGURATION_MODAL = 'SHOW_SAVE_CONFIGURATION_MODAL';
export const SHOW_SAVE_AS_CONFIGURATION_MODAL = 'SHOW_SAVE_AS_CONFIGURATION_MODAL';
export const SHOW_CONFIGURATION_ICON = 'SHOW_CONFIGURATION_ICON';
export const SYSTEM_TYPES_LOAD_BEGIN = 'SYSTEM_TYPES_LOAD_BEGIN';
export const SYSTEM_TYPES_LOAD_END = 'SYSTEM_TYPES_LOAD_END';
export const SYSTEM_TYPES_LOAD_ERROR = 'SYSTEM_TYPES_LOAD_ERROR';
export const TECHNICIAN_DATA_LOAD_BEGIN = 'TECHNICIAN_DATA_LOAD_BEGIN';
export const TECHNICIAN_DATA_LOAD_END = 'TECHNICIAN_DATA_LOAD_END';
export const TECHNICIAN_DATA_LOAD_ERROR = 'TECHNICIAN_DATA_LOAD_ERROR';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_CONTACT_LINKS_LOADING = 'TOGGLE_CONTACT_LINKS_LOADING';
export const TOGGLE_ERP_CLIENTS_LOADING = 'TOGGLE_ERP_CLIENTS_LOADING';
export const TOGGLE_LOAD_PROGRESS_BAR = 'TOGGLE_LOAD_PROGRESS_BAR';
export const TOGGLE_SITE = 'TOGGLE_SITE';
export const TOGGLE_SCORING = 'TOGGLE_SCORING';
export const TOGGLE_SCORING_LOAD_BEGIN = 'TOGGLE_SCORING_LOAD_BEGIN';
export const TOGGLE_SCORING_LOAD_END = 'TOGGLE_SCORING_LOAD_END';
export const TOGGLE_SCORING_LOAD_ERROR = 'TOGGLE_SCORING_LOAD_ERROR';
export const UPDATE_BILLING_INFO = 'UPDATE_BILLING_INFO';
export const UPDATE_TABLE_PROPS = 'UPDATE_TABLE_PROPS';
export const WEATHER_DATA_LOAD_BEGIN = 'WEATHER_DATA_LOAD_BEGIN';
export const WEATHER_DATA_LOAD_END = 'WEATHER_DATA_LOAD_END';
export const WEATHER_DATA_LOAD_ERROR = 'WEATHER_DATA_LOAD_ERROR';
export const RESET_BREAD_CRUMB = 'RESET_BREAD_CRUMB';
export const FETCH_APPOINTMENTS = 'FETCH_APPOINTMENTS';
export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS';
export const FETCH_ANNOUNCEMENT_MSG = 'FETCH_ANNOUNCEMENT_MSG';
export const FETCH_BACKGROUND_JOBS = 'FETCH_BACKGROUND_JOBS';
export const FETCH_REPORT_LIST = 'FETCH_REPORT_LIST';
export const CREATE_INSPECTION_REPORT = 'CREATE_INSPECTION_REPORT';
export const FETCH_REPORT_LISTS = 'FETCH_REPORT_LISTS';
export const UPDATE_CONFIGURATION_DATA = 'UPDATE_CONFIGURATION_DATA';
export const SET_IS_CLEAR_APPLIED_CONFIGURATION = 'SET_IS_CLEAR_APPLIED_CONFIGURATION';
export const SET_REDIRECTION = 'SET_REDIRECTION';
export const SET_IGNORE_DEFAULT_CONFIGURATION = 'SET_IGNORE_DEFAULT_CONFIGURATION';
export const FETCH_ALL_ROLES = 'FETCH_ALL_ROLES';
export const FETCH_ALL_ACTIVE_SCOPES = 'FETCH_ALL_ACTIVE_SCOPES';
